module.exports = __webpack_public_path__ + "img/ICONH_DT.72ced763.png";